import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import config from 'src/config';
import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig';
import api from 'src/actions/api';

class LoginFooter extends React.Component {
  render() {
    let { pageConfig, loading, toggleSignup, toggleContacts, signupState } = this.props;
    return (
      <div>
        {pageConfig.title == 'CashPlane' && (
          <div class='footer position-footer login-footer'>
            <div class='inner_footer clearfix'>
              <div class='foot_left'>
                <a href='#'>
                  <div class='logo adjust-logo'>CashPlane</div>
                </a>
              </div>
              <ul class='foot_right'>
                {false && (
                  <li>
                    <a href='/tos.html'>Affiliate terms</a>
                  </li>
                )}
                {false && (
                  <li>
                    <a href='/'>Our offer</a>
                  </li>
                )}
                <li>
                  <a href='/index.php?m=contact'>Contact</a>
                </li>
              </ul>
              <span class='clear_0'>&nbsp;</span>
            </div>
          </div>
        )}
        {pageConfig.newHome && (
          <div class='content-footer co__footer'>
            <div class='container'>
              <div class='row justify-content-center justify-content-md-between'>
                <div class='footer-menu col-12 col-md-auto'>
                  <ul class='menu-list d-flex align-items-center my-0 justify-content-around justify-content-md-start'>
                    <li class='menu-link py-3 py-md-4'>
                      <a href='/app/terms' target='_blank'>
                        Terms
                      </a>
                    </li>
                    <li class='menu-link py-3 py-md-4'>
                      <a href='/app/privacy'>Privacy</a>
                    </li>
                    <li class='menu-link py-3 py-md-4'>
                      <a onClick={toggleContacts}>Contact</a>
                    </li>
                  </ul>
                </div>
                <div class='footer-social'>
                  <ul class='social-list d-flex align-items-center my-0'>
                    <li class='social-link py-3 py-md-4'>
                      <a href='#'>
                        <i class='fa fa-facebook-f'></i>
                      </a>
                    </li>
                    <li class='social-link py-3 py-md-4'>
                      <a href='#'>
                        <i class='fa fa-twitter'></i>
                      </a>
                    </li>
                    <li class='social-link py-3 py-md-4'>
                      <a href={pageConfig.linkedIn}>
                        <i class='fa fa-linkedin'></i>
                      </a>
                    </li>
                    {pageConfig.footerText && (
                      <li class='social-link py-3 py-md-4'>
                        <span class='footer-text'>{pageConfig.footerText}</span>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        <div style={{ position: 'fixed', left: '10000px', top: '1000px' }}>
          <a href='https://www.sevencams.com'>sevencams.com</a>
          <a href='https://www.myflirtcams.com'>myflirtcams.com</a>
        </div>
      </div>
    );
  }
}

export default connect(function (state) {
  return {};
}, {})(LoginFooter);
